import qs from 'qs';
import client from './client';

const chanceUrl = '/api/v1/project/forecast';

const commentUrl = '/api/v1/project/board';
const costCalcUrl = '/api/v1/project/expense';
const estimateUrl = '/api/v1/project/quote';
const orderUrl = '/api/v1/project/orders';

 
//매출 견적서 가져오기
export const getFiles = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`/api/v1/file/list?${queryString}`);
};

//기회 리스트 가져오기(추후에 검색어 기능 달기)
export const getChances = (searchData) => {
  const queryString = qs.stringify(searchData);
  // console.log(queryString, 'queryString');
  return client.get(`${chanceUrl}/list?${queryString}`);
};

export const getBaseChances = (searchData) => {
  const queryString = qs.stringify(searchData);
  // console.log(queryString, 'queryString');
  return client.get(`${chanceUrl}/list/base?${queryString}`);
};

//기회 추가
export const addChance = (dataToSubmit) => {
  return client.post(`${chanceUrl}/info`, dataToSubmit);
};

export const addChanceStep2 = (dataToSubmit) => {
  return client.post(`${chanceUrl}/info/step2`, dataToSubmit);
};

//기회 정보 가져오기
export const getChance = (id) => client.get(`${chanceUrl}/info/${id}`);

export const editChance = (dataToSubmit) => {
  return client.put(`${chanceUrl}/info/${dataToSubmit.prjUuid}`, dataToSubmit);
};

//포캐스팅 복사
export const copyChance = (id) => client.get(`${chanceUrl}/copy/${id}`);

//기회 삭제
export const removeChance = (id) => client.delete(`${chanceUrl}/info/${id}`);

// 삭제 권한. 본인이 만든 것이거나 삭제 권한자여야 한다. ksm_backend/ksm_frontend 포팅(2026-10-19).
export const getChanceDeletePermission = (id) =>
  client.get(`${chanceUrl}/info/${id}/delete-permission`);

//영업활동 가져오기
export const getComments = (id) => {
  return client.get(`${commentUrl}/prj/${id}/I`);
};

//영업이력 가져오기
export const getHistory = (id) => {
  return client.get(`${commentUrl}/prj/${id}/H`);
};

export const addComment = (dataToSubmit) => {
  return client.post(`${commentUrl}/info`, dataToSubmit);
};

export const editComment = (dataToSubmit) => {
  return client.put(
    `${commentUrl}/info/${dataToSubmit.prjUuid}/${dataToSubmit.brdUuid}`,
    dataToSubmit,
  );
};

export const removeComment = (id) => {
  return client.delete(`${commentUrl}/info/${id}`);
};

//파일 가져오기 :fileTyp => project, prjUuid
export const getChanceFiles = ({ fileTyp, fileAttrVal1 }) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};

export const getPrjTechFiles = ({ fileTyp, fileAttrVal1 }) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
  });
  return client.get(`/api/v1/file/list/tech?${queryString}`);
};

export const getPurchseOrderFiles = ({
  fileTyp,
  fileAttrVal1,
  fileAttrVal2,
}) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
    fileAttrVal2,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};

//매입견적서 가져오기
// 2026-10-23 (250423 피드백 #12): fileAttrVal2("매입견적서"/"매출견적서" 태그)를
// 필터로 추가 — 전엔 안 넘겨서 같은 견적(qteUuid)에 올라간 매출/매입 견적서 파일이
// 한 리스트에 섞여 보였다. 백엔드 selectFileInf는 이미 fileAttrVal2 필터를 지원한다.
export const getPurchaseQuoteFiles = ({
  fileTyp,
  fileAttrVal1,
  fileAttrVal2,
  fileAttrVal3,
}) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
    fileAttrVal2,
    fileAttrVal3,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};

//매출견적서 가져오기 (2026-10-23, 250423 피드백 #12 — 매입과 분리)
export const getSalesQuoteFiles = ({
  fileTyp,
  fileAttrVal1,
  fileAttrVal2,
  fileAttrVal3,
}) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
    fileAttrVal2,
    fileAttrVal3,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};

//수주품의서 파일 가져오기
export const getOrderFiles = ({ fileTyp, fileAttrVal1, fileAttrVal3 }) => {
  const queryString = qs.stringify({
    fileTyp,
    fileAttrVal1,
    fileAttrVal3,
  });
  return client.get(`/api/v1/file/list?${queryString}`);
};

//프로젝트 원가 산출 리스트
export const getCosts = (id) => {
  return client.get(`${costCalcUrl}/prj/${id}`);
};

//프로젝트 원가 등록
export const addCosts = (id, dataToSubmit) => {
  return client.post(`${costCalcUrl}/prj/${id}`, dataToSubmit);
};

//프로젝트 원가 수정
export const editCost = (dataToSubmit) => {
  return client.put(
    `${costCalcUrl}/info/${dataToSubmit.prjUuid}/${dataToSubmit.expUuid}`,
    dataToSubmit,
  );
};

//프로젝트 원가 수정
export const editCosts = (prjUuid, dataToSubmit) => {
  return client.put(`${costCalcUrl}/info/${prjUuid}`, dataToSubmit);
};

//프로젝트 원가 삭제
export const removeCost = (id) => {
  return client.delete(`${costCalcUrl}/info/${id}`);
};

//프로젝트 원가 확정
export const completeCost = (id) => {
  return client.put(`${costCalcUrl}/cost/${id}`);
};

//프로젝트 원가산출 해제
export const unDoCost = (id) => {
  return client.put(`${costCalcUrl}/cost/${id}/undo`);
};

//프로젝트 원가산출 엑셀 업로드
export const uploadExl = (formData) => {
  return client.post(`${costCalcUrl}/uploadExl`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
};

//Active한 견적서 내역 가져오기
export const getActiveEstimate = (id) => {
  return client.get(`${estimateUrl}/info/${id}/active`);
};

//프로젝트 견적서 count
export const getEstimateCount = (id) => {
  return client.get(`${estimateUrl}/info/${id}/count`);
};

//견적서 원가산출 리스트 => /api/v1/project/quote/detail/{qteUuid}
export const getEstimateCosts = (id) => {
  return client.get(`${estimateUrl}/detail/${id}`);
};

//프로젝트 견적 리스트
export const getEstimates = (id) => {
  return client.get(`${estimateUrl}/info/${id}`);
};

//견적 등록
export const addEstimate = (dataToSubmit) => {
  return client.post(`${estimateUrl}/info`, dataToSubmit);
};

//견적 수정
export const editEstimate = (dataToSubmit) => {
  return client.put(
    `${estimateUrl}/info/${dataToSubmit.prjUuid}/${dataToSubmit.qteUuid}`,
    dataToSubmit,
  );
};

//견적 삭제
export const removeEstimate = (prjId, id) => {
  return client.delete(`${estimateUrl}/info/${prjId}/${id}`);
};

//견적 엑셀
export const downloadExcel = (id) => {
  //return client.get(`${estimateUrl}/print/${id}/file`)
  return client.get(`${estimateUrl}/print/${id}/file`, {
    responseType: 'arraybuffer',
  });
};

export const downloadPdf = (id) => {
  return client.get(`${estimateUrl}/print/preview/test`, {
    responseType: 'arraybuffer',
  });
};

// 견적서 PDF 다운로드/미리보기 (Excel → PDF 변환, 서버/Gotenberg, 2026-10-20 ksm 포팅)
export const downloadQuotePdf = (id) => {
  return client.get(`${estimateUrl}/print/${id}/pdf`, {
    responseType: 'arraybuffer',
  });
};

//프로젝트 수주품의서 가져오기
export const getChanceOrderHistory = (id) => {
  return client.get(`${orderUrl}/list/${id}`);
};

//프로젝트의 활성화된 수주 확인
export const getChanceOrderCount = (id) =>
  client.get(`${orderUrl}/list/${id}/count`);
